import apiClient from './apiClient';

export interface TeamMember {
  id: string;
  name: string;
  headshot_url: string | null;
  university: string | null;
  major: string | null;
  class: string | null;
  email: string | null;
  linkedin_url: string | null;
  github_url: string | null;
  resume_url: string | null;
  website_url: string | null;
}

export const aboutApi = {
  getTeamMembers: async (): Promise<TeamMember[]> => {
    const response = await apiClient.get('/api/about/team');
    return response.data.team_members;
  },
};

